import React from 'react';
import { THEME_WHITE } from '../../../constants/styling/themes';
import SelectField from '../../forms/SelectField';
import Datepicker from '../../forms/Datepicker';

const PerformancesForm = ({ data, artists, onInput, stages, openArtist }) => {
    return (
        <form className="ckp-admin-performances-form-inputs">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column">
                    <SelectField
                        name="stageIdentifier"
                        value={data.stageIdentifier}
                        label="Stage"
                        items={stages}
                        onChange={onInput}
                        theme={THEME_WHITE}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        items={artists}
                        value={data.artistId}
                        name="artistId"
                        label="Artist"
                        onChange={onInput}
                        theme={THEME_WHITE}
                        actionLabel="Create Artist"
                        action={openArtist}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <Datepicker
                        value={data.start}
                        timePicker={true}
                        name="start"
                        label="Starts"
                        onChange={onInput}
                        theme={THEME_WHITE}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <Datepicker
                        value={data.end}
                        timePicker={true}
                        name="end"
                        label="Ends"
                        minDate={data.start}
                        onChange={onInput}
                        theme={THEME_WHITE}
                    />
                </div>
            </div>
        </form>
    );
};

export default PerformancesForm;
